import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabNavigationService } from '../../../services/tab-navigation.service';
import { ScrollService } from '../../../services/page-scroll.service';
@Component({
    selector: 'app-step-1',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './step-1.component.html',
    styleUrl: './step-1.component.scss',
})
export class Step1Component implements OnChanges {
    @Input() data: any;
    checklist: any = [];
    gaId = '';
    constructor(
        private tabNavigationService: TabNavigationService,
        private scrollService: ScrollService
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']) {
            const chData = changes?.data?.currentValue;

            this.gaId = chData?.switcher1group + '_download_button_jc3_click';
            for (let i = 1; i <= 10; i++) {
                if (chData[`checklist${i}`]) {
                    this.checklist.push(chData[`checklist${i}`]);
                }
            }
        }
    }

    navigateToTabs(mainTab: string, subTab: string) {
        this.tabNavigationService.navigateToTab(mainTab, subTab);
    }

    scrollToTop() {
        this.scrollService.scrollToPosition(0, 'smooth');
    }

    understandingList = [
        'Attend relevant capacity building programmes to acquire basic ESG knowledge (including basic ESG concepts and best practices).',
        'Find out ESG-related requirements or expectations of key stakeholders (e.g. ESG practices imposed by MNC or PLC clients, ESG criteria set by lenders and investors).',
        'Consider significant ESG-related impacts arising from company’s operations (e.g. activities that produce significant amounts of GHG emissions).',
        'Develop awareness of key ESG-related regulatory developments, standards and best practices in the market or industry (e.g. upcoming energy efficiency regulations, recommended ESG disclosures for Malaysian SMEs).',
    ];
}
